import React from 'react';
import { Project } from '@/types';
import { FolderKanban, Plus, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ProjectHeaderProps {
  project: Project;
  onNewChat: () => void;
  isCreatingChat: boolean;
}

const ProjectHeader = ({ project, onNewChat, isCreatingChat }: ProjectHeaderProps) => {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h1 className="text-4xl font-bold flex items-center justify-center gap-3">
          <FolderKanban className="h-8 w-8 text-muted-foreground" />
          {project.name}
        </h1>
        {project.description && (
          <p className="text-muted-foreground mt-2 max-w-2xl mx-auto">{project.description}</p>
        )}
      </div>
      
      <div className="max-w-3xl mx-auto">
        <Button 
          variant="outline" 
          className="group w-full h-14 text-left justify-start px-4 text-base"
          onClick={onNewChat}
          disabled={isCreatingChat}
        >
          <div className="flex items-center w-full">
            {isCreatingChat ? (
              <Loader2 className="h-5 w-5 mr-3 animate-spin" />
            ) : (
              <Plus className="h-5 w-5 mr-3" />
            )}
            <span className="text-muted-foreground group-hover:text-white transition-colors">
              {isCreatingChat ? 'Creating new chat...' : `New chat in ${project.name}`}
            </span>
          </div>
        </Button>
      </div>

    </div>
  );
};

export default ProjectHeader;